import {
  TAGInvItemGroup,
  TAGInvItemInstance,
  TAGInvItemType,
  TAGInvTransaction,
} from '../../../models/taginventory';
import { ApiService } from '../../api.service';

export function extractItemInstanceID(barcode: string) {
  // Count the amount of dashes in code
  let dashCount = (barcode.match(/-/g) || []).length;

  if (dashCount == 1) {
    let itemID = barcode.split('-')[0].trim();
    let instanceID = barcode.split('-')[1].trim();

    return { itemID, instanceID };
  }

  return { itemID: undefined, instanceID: undefined };
}

export function getInventoryInstanceByCode(barcode: string, api: ApiService) {
  return new Promise<{ item: TAGInvItemType; instanceID: string }>((resolve, reject) => {
    let { itemID, instanceID } = extractItemInstanceID(barcode);

    let promises = [];

    if (itemID && instanceID) {
      promises.push(
        new Promise<{ item: TAGInvItemType; instanceID: string }>((resolve, reject) => {
          api
            .getInvItem(itemID)
            .then((item) => {
              resolve({ item, instanceID });
            })
            .catch((reason) => {
              resolve(undefined);
            });
        }),
      );
    }

    promises.push(
      new Promise<{ item: TAGInvItemType; instanceID: string }>((resolve, reject) => {
        api
          .findInvItem(barcode)
          .then((item) => {
            resolve({ item, instanceID: undefined });
          })
          .catch((reason) => {
            resolve(undefined);
          });
      }),
    );

    Promise.all(promises)
      .then((results) => {
        for (let result of results) {
          if (result) {
            let item = result.item;

            if (result.instanceID) {
              resolve({ item, instanceID: result.instanceID });
            } else {
              let instanceID = undefined;

              for (let instance of item.instances) {
                if (instance.barcodes.includes(barcode)) {
                  instanceID = instance.itemid;
                  break;
                }
              }

              resolve({ item, instanceID });
            }

            return;
          }
        }

        reject('No item found');
      })
      .catch((reason) => {
        reject(reason);
      });
  });
}

export function getLocalInventoryInstanceByCode(barcode: string, items: TAGInvItemType[]) {
  //TODO: deprecate
  let { itemID, instanceID } = extractItemInstanceID(barcode);

  if (itemID) {
    let item = items.find((item) => item._id == itemID);
    if (item) {
      let instance = undefined;

      if (instanceID) {
        instance = item.instances.find((inst) => inst.itemid == instanceID);
      }

      return { item, instanceID: instance?.itemid };
    }
  } else {
    let item = items.find((item) => item._id == barcode);
    if (item) {
      return { item, instanceID: undefined };
    } else {
      let item = items.find((item) =>
        item.instances.some((inst) => inst.barcodes.includes(barcode)),
      );
      if (item) {
        let instance = item.instances.find((inst) => inst.barcodes.includes(barcode));
        return { item, instanceID: instance?.itemid };
      }
    }
  }

  return { item: undefined, instanceID: undefined };
}

export function findInvByCode(
  code: string,
  items?: TAGInvItemType[],
  groups?: TAGInvItemGroup[],
  transactions?: TAGInvTransaction[],
  api?: ApiService,
) {
  return new Promise<{ item?: TAGInvItemType, instance?: TAGInvItemInstance, group?: TAGInvItemGroup, transaction?: TAGInvTransaction }>(async (resolve, reject) => {
    let { itemID, instanceID } = extractItemInstanceID(code);

    let item: TAGInvItemType = undefined;
    let instance: TAGInvItemInstance = undefined;
    let group: TAGInvItemGroup = undefined;
    let transaction: TAGInvTransaction = undefined;

    // Search item & instance directly by id
    if (itemID) {
      if (items != undefined) item = items.find((i) => i._id === itemID);
      else if (api != undefined) {
        try {
          item = await api.getInvItem(itemID);
        } catch (reason) {}
      }

      if (item && instanceID) {
        instance = item.instances.find((inst) => inst.itemid === instanceID);
      }
    }

    // Find Item by extra barcode
    if (!item) {
      if (items != undefined) {
        item = items.find((item) => item.instances.some((inst) => inst.barcodes.includes(code)));
        if (item) {
          instance = item.instances.find((inst) => inst.barcodes.includes(code));
        }
      } else if (api != undefined) {
        try {
          item = await api.findInvItem(code);
          if (item) {
            instance = item.instances.find((inst) => inst.barcodes.includes(code));
          }
          console.log(item, instance);
        } catch (reason) {}
      }
    }

    if (!item && groups) {
      if (groups != undefined) group = groups.find((g) => g._id === code);
      else if (api != undefined) {
        try {
          group = await api.getInvItemGroup(code);
        } catch (reason) {}
      }
    }

    if (!item && !group && transactions) {
      if (transactions != undefined) transaction = transactions.find((t) => t._id === code);
      else if (api != undefined) {
        try {
          transaction = await api.getInvTransaction(code);
        } catch (reason) {}
      }
    }

    resolve({ item, instance, group, transaction });
  });
}
